import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  margin: 20px auto;
  display: flex;
  background-color: #fff;
  align-items: center;
  padding: 5px;
  box-shadow: rgba(0, 0, 0, 0.15) -3px 3px 5px 0px;
`;

export const Input = styled.input`
  font-family: Roboto, Helvetica, Arial, sans-serif;
  border: none;
  padding: 10px;
  background-color: #fff;
  flex: 1;
  font-size: 16px;

  :focus {
    outline: none;
  }
`;

export const Span = styled.span`
  position: absolute;
  bottom: -17px;
  right: 0;
  font-size: 11px;
  color: #a0a0a0;
`;
